export type CallToActionPosition = "above" | "below" | "left" | "right";
type Placement = { clearance: number; position: CallToActionPosition };

export const calculateCallToActionPositions = (
  containerRect: DOMRect,
  targetRect: DOMRect,
  viewport: { height: number; width: number },
  highlightElement: boolean,
) => {
  const cutout = {
    radius: Math.sqrt(targetRect.height ** 2 + targetRect.width ** 2) / 2,
    x: targetRect.left + targetRect.width / 2,
    y: targetRect.top + targetRect.height / 2,
  };

  const cutoutTop = targetRect.top + targetRect.height / 2 - cutout.radius;
  const cutoutLeft = targetRect.left + targetRect.width / 2 - cutout.radius;
  const cutoutDiameter = 2 * cutout.radius;

  let placement: Placement = {
    clearance: viewport.height - cutoutTop - cutoutDiameter,
    position: "below",
  };

  const options: Placement[] = [];
  if (containerRect.width + SPACING <= viewport.width - cutoutLeft - cutoutDiameter)
    options.push({ clearance: viewport.width - cutoutLeft - cutoutDiameter, position: "right" } as const);
  if (containerRect.height + SPACING <= cutoutTop) options.push({ clearance: cutoutTop, position: "above" } as const);
  if (containerRect.width + SPACING <= cutoutLeft) options.push({ clearance: cutoutLeft, position: "left" } as const);

  for (const option of options) if (option.clearance > placement.clearance) placement = option;

  let top = cutoutTop;
  let left = cutoutLeft;

  switch (placement.position) {
    case "above": {
      top += -SPACING - containerRect.height;
      left += cutoutDiameter / 2 - containerRect.width / 2;
      break;
    }
    case "right": {
      top += cutoutDiameter / 2 - containerRect.height / 2;
      left += cutoutDiameter + SPACING;
      break;
    }
    case "below": {
      top += cutoutDiameter + SPACING;
      left += cutoutDiameter / 2 - containerRect.width / 2;
      break;
    }
    case "left": {
      top += cutoutDiameter / 2 - containerRect.height / 2;
      left += -SPACING - containerRect.width;
      break;
    }
  }

  if (top + containerRect.height > viewport.height) top = viewport.height - containerRect.height;

  const fullscreen =
    !highlightElement ||
    (placement.position === "below" && cutoutTop + cutoutDiameter + SPACING + containerRect.height > viewport.height);

  if (fullscreen) {
    left = (viewport.width - containerRect.width) / 2;
    top = (viewport.height - containerRect.height) / 2;
    cutout.radius = 0;
  }

  if (left < 0) left = 0;
  if (top < 0) top = 0;

  const width = Math.min(CALL_TO_ACTION_MAX_WIDTH, viewport.width);
  return { cutout, popup: { fullscreen, left, position: placement.position, top, width } };
};

export const CALL_TO_ACTION_MAX_WIDTH = 464;
const SPACING = 32;
